import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { editContent } from '../../modules/editor';
import useOnClickOutside from  '../../hooks/useOnClickOutside';
import { isNumber } from '../../util/validator';
import { ReactSVG } from 'react-svg';
import { getPathAfterBuild } from '../../util/file';

type Props = {
	target: string;
	value: string|undefined;
	options: any[];
	size?: 'full' | 'medium' | 'medismall' | 'small' | 'tiny';
};

function TextAlignDropdown({ target, value, options, size }: Props) {
	const [open, setOpen] = useState(false);
	const dispatch = useDispatch();

	const iconImage = (path) => {
		const context = require.context('../../assets/images/', true);
		return getPathAfterBuild(context, path);
	};

	const toggleOpen = () => {		
		setOpen(!open);
	} 

	const onSelect = (item:any) => {
		const { value } = item;
		dispatch(editContent({ target: target, data: isNumber(value) ? `${value}px` : value }));
		toggleOpen()
	}

	const ref = useRef(null);
	useOnClickOutside(ref, ():any => {
		setOpen(false);
  });

	return (
    <div className={size ? `select text-align ${size}` : 'select text-align'} ref={ref}>
      <div className={open ? 'select-header open' : 'select-header'} onClick={toggleOpen}>
        <strong>
					<ReactSVG src={iconImage(`./icon/toolbar/align-${value}.svg`)} width="10" />
				</strong>
        <ReactSVG className="caret" src={iconImage(`./icon/toolbar/arrow_down.svg`)} width="10" />
      </div>
      {
        open && (
        <div className="select-body">
          <ul>
            {
              options.map((item:any, index:number) => (
                <li key={index} className={(isNumber(item.value) ? `${item.value}px` : item.value) === (value === '0' ? '0px' : value) ? 'active' : ''}>
                  <button type="button" onClick={() => onSelect(item)}>
										<ReactSVG src={iconImage(`./icon/toolbar/align-${item.value}.svg`)} width="10" />
                  </button>
                </li>
              ))
            }
          </ul>
        </div>
        )
      }
    </div>
	);
}

export default TextAlignDropdown;